import React from "react";

import { Activity, Trophy, TrendingUp } from "lucide-react";

type ComingSoonProps = {
  title?: string;
  description?: string;
};

const ComingSoon: React.FC<ComingSoonProps> = ({
  title = "Coming soon",
  description = "We are working on this section. Check back shortly.",
}) => {
  if (title === "Goals & Milestones") {
    return (
      <div className="relative w-full min-h-[calc(100vh-7rem)] bg-white h-full">
        <div className="absolute inset-0 z-50 flex items-center justify-center p-4">
          <div className="text-center bg-white rounded-2xl p-8 shadow-2xl border border-gray-200 max-w-lg mx-4">
            <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <Trophy className="h-8 w-8 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">
              Goals & Milestones Coming Soon!
            </h2>
            <p className="text-gray-600 mb-6">
              We&apos;re building a comprehensive milestone tracking system with
              gamification and achievement rewards.
            </p>
            <div className="text-sm text-gray-500">
              Stay tuned for updates - launching soon!
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (title === "Leaderboard") {
    return (
      <div className="relative w-full min-h-[calc(100vh-7rem)] bg-white h-full">
        <div className="absolute inset-0 z-50 flex items-center justify-center p-4">
          <div className="text-center bg-white rounded-2xl p-8 shadow-2xl border border-gray-200 max-w-lg mx-4">
            <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <Trophy className="h-8 w-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">
              Leaderboard Coming Soon!
            </h3>
            <p className="text-gray-600 mb-6">
              We&apos;re building an exciting leaderboard experience to showcase
              top performers and achievements.
            </p>
            <div className="text-sm text-gray-500">
              Stay tuned for updates - launching soon!
            </div>
            {/* <div className="flex items-center justify-center space-x-6 text-sm text-gray-500">
              <div className="text-center">
                <div className="text-2xl font-bold text-purple-600">85</div>
                <div>Top Score</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-indigo-600">12</div>
                <div>Participants</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-green-600">94%</div>
                <div>Completion Rate</div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }

  if (title === "Dashboard") {
    return (
      <div className="relative w-full min-h-[calc(100vh-7rem)] bg-white h-full">
        <div className="absolute inset-0 z-50 flex items-center justify-center p-4">
          <div className="text-center bg-white rounded-2xl p-8 shadow-2xl border border-gray-200 max-w-lg mx-4">
            <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <TrendingUp className="h-8 w-8 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">
              Dashboard Coming Soon!
            </h2>
            <p className="text-gray-600 mb-6">
              We&apos;re building an amazing dashboard experience with advanced
              analytics, real-time insights, and powerful visualizations.
            </p>
            <div className="text-sm text-gray-500">
              Stay tuned for updates - launching soon!
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full min-h-[60vh] items-center justify-center py-10">
      <div className="mx-auto w-full max-w-3xl rounded-xl border border-dashed border-gray-200 bg-white p-8 text-center text-gray-600 shadow-sm">
        <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
          <Activity size={20} className="text-gray-600" />
        </div>
        <div className="text-lg font-semibold text-gray-900">{title}</div>
        <div className="mt-1 text-sm text-gray-500">{description}</div>
      </div>
    </div>
  );
};

export default ComingSoon;
